import React from 'react';
import { Location } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { RouteAnimation } from './animations/animations';

type RouteAnimationState = {
  animation?: RouteAnimation;
};

type TransitionsProps = {
  children: React.ReactNode;
  location: Location;
};

export const Transitions = ({ location, children }: TransitionsProps) => {
  const { state, key } = location;
  const animation = (state as RouteAnimationState)?.animation;

  return (
    <TransitionGroup
      style={{ padding: 'inherit' }}
      childFactory={child =>
        React.cloneElement(child, {
          classNames: animation ?? RouteAnimation.Fade
        })
      }
    >
      <CSSTransition key={key} timeout={300}>
        <div className={animation ?? RouteAnimation.Fade}>{children}</div>
      </CSSTransition>
    </TransitionGroup>
  );
};
